var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 27,
    viewBox: "0 0 70 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.735C7.86309 25.735 15.1954 26.4691 21.9194 25.0604C27.2378 23.9461 33.5467 24.3984 38.4806 22.0726C44.393 19.2856 51.9529 18.5274 56.5913 13.3985C58.8864 10.8609 66.8351 5.57644 67.2447 2.31502C67.4268 0.865533 69.5235 0.674325 68.5522 1.44761C67.868 1.99231 66.4321 3.1681 66.3731 4.04983C66.3011 5.12393 66.1788 1.88172 66.7605 1.4958C67.7167 0.861419 64.2721 2.15952 63.7582 3.18242",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrow);
export default __webpack_public_path__ + "static/media/icons_arrow.54cfac8ceaef46773dd82fe08d201cf0.svg";
export { ForwardRef as ReactComponent };